import {
  Box,
  Flex,
  HStack,
  IconButton,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { X } from 'lucide-react'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

import { Buttons } from '@/components/shared/buttons'
import { ConfirmationDialog } from '@/components/shared/displayers/ConfirmationDialog'
import { ImageContainer } from '@/components/shared/displayers/ImageContainer'
import { UpdatedAtLabel } from '@/components/shared/feedback/UpdatedAtLabel'
import { Can } from '@/features/sessao/providers/auth-context'
import { Repository } from '@/services/repository'

import { Chamados } from '..'

type Props = {
  callId?: number
  isEditable?: boolean
}

export default function Component({ callId, isEditable }: Props) {
  const confirmation = useDisclosure()
  const { Delete } = Repository.Entity.CallTechAttachment

  const { data, isFetching, dataUpdatedAt, refetch } = useQuery(
    ['callTechAttachment-gallery', callId],
    async () => {
      if (callId)
        return await Repository.Entity.CallTechAttachment.Search({
          callId: Number(callId),
        })
    },
  )

  const onDelete = async (id: string) => {
    try {
      await Delete({ id })
      toast.success('Evidência removida com sucesso')
      refetch()
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  return (
    <Box>
      <Box mb={4}>
        <HStack>
          {callId && isEditable && (
            <Chamados.Tecnico.Evidencias.Adicionar_Dialog
              callId={Number(callId)}
              onSuccess={() => refetch()}
            />
          )}
          <Buttons.Refresh isLoading={isFetching} onClick={() => refetch()} />
        </HStack>

        <UpdatedAtLabel updatedAt={dataUpdatedAt} />
      </Box>

      <Flex flexWrap="wrap" gap={2}>
        {(data ?? []).map((ea: any) => (
          <Box key={ea.id} position="relative">
            <ImageContainer src={ea.imageStr} size="sm" />

            {isEditable && (
              <Can asDefault I="delete" a="CallReportAttachment">
                <IconButton
                  size="xs"
                  top={2}
                  right={2}
                  position="absolute"
                  aria-label="Excluir"
                  icon={<X />}
                  colorScheme="primary"
                  onClick={confirmation.onOpen}
                />
              </Can>
            )}

            <ConfirmationDialog
              {...confirmation}
              onConfirm={() => onDelete(ea.id)}
            >
              Confirma exclusão da evidência?
            </ConfirmationDialog>
          </Box>
        ))}

        {(data ?? []).length === 0 && <Text>Galeria vazia</Text>}
      </Flex>
    </Box>
  )
}
